//import { useEffect, useMemo, useState } from "react";
//import { useParams } from "react-router-dom";
//import useWebSocket, { ReadyState } from "react-use-websocket"
//import { config } from "config";
import { useBingoGamePoll } from "bingo/hooks/useBingoGamePoll";
import { useEffect } from "react";
import { setRunningBingoGameActive } from "visibilityState";
//import { quizMode, quizScreenType } from "quiz/types/quiz.model";

//import type { GameState } from "quiz/types/game.model";
//import type { WebsocketMessage } from "common/models/WebsocketMessage.model";

import { RunningBingoGame } from "./RunningBingoGame";

export function RunningBingoGamePresenter() {
  useEffect(() => {
    setRunningBingoGameActive(true); // Enable exception

    return () => setRunningBingoGameActive(false); // Reset on unmount
  }, []);
  //const { bingoGameId } = useParams();
  const bingoGame = useBingoGamePoll(1000); // polling every 1 second
  //const bingoGame = useBingoGame();
  //   const [bingoGameState, setBingoGameState] = useState<GameState>(
  //     bingoGame!.state,
  //   );

  //const quiz = game!.quizSnapshot;
  // const bingoTemplate = bingoGame!.bingoTemplateSnapshot;
  //const screenType = "1540px 220px";
  const backgroundSize = "1540px 220px";

  //   const backgroundSize = useMemo(
  //     () =>
  //       bingoTemplate?.publicScreenSettings === "bandeau_horizontal"
  //         ? "1540px 220px"
  //         : "1920px 1080px",
  //     [bingoTemplate],
  //   );

  /*
  const { sendJsonMessage, lastJsonMessage, readyState } =
    useWebSocket<WebsocketMessage>(config.wsApiRoot, {
      retryOnError: true,
      shouldReconnect: (closeEvent) => true,
    });


  useEffect(() => {
    if (readyState === ReadyState.OPEN) {
      sendJsonMessage({
        action: "register",
        payload: {
          appName: "screen",
          gameId,
        },
      });
    }
  }, [readyState, bingoGame, sendJsonMessage, bingoGameId]);

  

  useEffect(() => {
    if (lastJsonMessage?.type === "state") {
      setGameState(lastJsonMessage.payload);
    }
  }, [lastJsonMessage]);
*/
  if (bingoGame) {
    return (
      // <RunningBingoGame
      //   backgroundSize={backgroundSize}
      //   // bingoGame={bingoGame}
      //   // gameState={gameState}
      //   // bingoTemplate={bingoTemplate}
      //   // screenType={screenType}
      // />

      <RunningBingoGame backgroundSize={backgroundSize} bingoGame={bingoGame} />
    );
  }

  return null;
}
